require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/babel-polyfill/~/core-js/modules/es7.symbol.observable.js
// module id = 810
// module chunks = 0